<template>
    <el-card>
        <p slot="header">
            {{warehouse.name}}
        </p>
        <a href="#" slot="extra" @click.prevent="refreshBase">
            <i class="ios-loop-strong"></i>
            刷新
        </a>
        <div class="fitem">
            账户余额：{{account}}元
        </div>
        <div class="fitem">
            <el-input type="number" size="small" v-model="money" style="width: 200px" placeholder="请输入充值金额,100起提"></el-input>
            <el-button size="small" type="primary" @click="recharge" :loading="rechargeLoading">提现</el-button>
        </div>
    </el-card> 
</template>
<script>
import Constants from "@/utils/constants"
export default {
    name: 'Recharge',
    data() {
        return {
            money: '',
            account: '',
            rechargeLoading: false
        };
    },
    props: [
        'warehouse'
    ],
    mounted: function() {
        // var me = this;
        // me.refreshBase();
         this.account = this.warehouse.account;

    },
    watch: {
        "warehouse": {
            handler(nval, oval) {

                this.account = nval.account;
            }
        }
    },
    components: {

    },
    computed: {

    },
    beforeRouteLeave(to, from, next) {



        next();
    },
    beforeRouteUpdate(to, from, next) {



        next();
    },
    beforeRouteEnter(to, from, next) {

        next();
    },
    methods: {
        recharge: function() {
            var me = this;
            if (!me.money || me.money <= 0) {
                me.$message.error("请输入提现金额")
                return;
            }
            // if (me.money < 1 || me.money > 2000) {
            //     me.$message.error("提现：1-2000元")
            //     return;
            // };
            me.rechargeLoading = true;
            me.$http.post("/ware/deposit/dosave.action", { warehouseId: me.warehouse.id, money: me.money }).then(response => {
                var body = response;
                if (body.status == 0) {
                    me.$message.success("提现成功");
                    me.$router.push({ name: "DepositList" });
                } else if (body.status == 3) {
                    me.$Modal.info({
                        title: "提醒",
                        content: "请先绑定微信",
                        okText: "去绑定",
                        onOk: function() {
                            me.$router.push({ name: "Weixin" })
                        },
                        onCancel: function() {

                        }
                    });
                } else {
                    me.$message.success(body.info);
                }
                me.rechargeLoading = false;
            }, response => {
                me.rechargeLoading = false;
            });
        },
        refreshBase: function() {
            var me = this;
            me.loading = true;
            me.$http.post("/ware/user/getaccount.action", { warehouseId: me.warehouse.id }).then(response => {
                var body = response;
                if (body.status == 0) {
                    me.account = body.obj.account;
                } else {
                    me.$message.error("异常！" + me.info);
                }
                me.loading = false;
            }, response => {
                me.loading = false;
            });
        }
    }
}
</script>
<style scoped>
.fitem {
    line-height: 3;
    font-size: 14px;
}
</style>